<template>
  <div class="mb-3">
    <custom-callout
      class="custom-callout"
      :class="[{ 'bg-white': fromAcquisition }]"
      :opened="isPanelOpen"
      :controlled="true"
      :border-color="item.statusColor"
      @click:open="onToggle()"
    >
      <div class="row">
        <div
          :class="{
            'col-11':
              (isProcessed || isAvailable || isInactivated || isReturned) &&
              checkable,
            'col-12': !(
              (isProcessed || isAvailable || isInactivated || isReturned) &&
              checkable
            ),
          }"
        >
          <div class="row py-3">
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estatus:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                <custom-balloon
                  :background-color="item.statusColor"
                  class="mt-2"
                  :text="item.statusName"
                  dot
                />
              </div>
            </div>
            <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre del Material/Equipo:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.title | empty }}
              </div>
            </div>
            <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Código:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.code | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Tipo de Salón:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.saloonType | empty }}
              </div>
            </div>
            <div class="col">
              <drop-down
                always-show-dropdown
                :items="actionItems"
                class="float-md-right mr-5"
              />
            </div>
          </div>
          <div class="col-12 border-bottom-2"></div>
          <div class="row py-3">
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Tipo de Localidad:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ locationTypeName | empty }}
              </div>
            </div>
            <div v-if="!isLocationCSEE" class="col-md-3 col-12">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Centro:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.caat | empty }}
              </div>
            </div>
            <div v-if="isLocationSchool" class="col-md-3 col-12">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Municipio:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.municipality | empty }}
              </div>
            </div>
            <div v-if="isLocationSchool" class="col-md col-12">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Escuela:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.school | empty }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            checkable &&
              (isProcessed || isAvailable || isInactivated || isReturned)
          "
          class="col border-left"
        >
          <div class="d-flex justify-content-center align-items-center h-100">
            <checkbox
              checked-bg-color="bg-success"
              icon="fal fa-check"
              class="d-flex justify-content-center"
              v-model="item.checked"
              @input="check(item)"
            />
          </div>
        </div>
      </div>
      <template #edition>
        <div v-if="showTransfer" class="p-1 ">
          <div class="px-5 py-4">
            <icon-view
              class="mb-3"
              :has-border="false"
              icon="far fa-exchange text-orange"
              icon-size="17px"
              title="Solicitud de Transferencia de Material/Equipo"
              variant="custom-icon-view"
              icon-background="white"
            />
            <transfer-request
              :order="order"
              :item="item"
              @close="onCloseCallout()"
            />
          </div>
        </div>
        <div v-if="showBinnacle" class="px-5 py-4">
          <validation-observer ref="binnacleForm">
            <div class="mb-3">
              <icon-view
                :has-border="false"
                icon="mt-1 fas fa-comment text-orange"
                icon-size="18px"
                title="Añadir Bitácora"
                variant="custom-icon-view"
                icon-background="white"
              />
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="color-secondary-6 font-14">
                  Asunto:
                </div>
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-input
                    placeholder="Asunto"
                    :error="errors[0]"
                    custom-error-msg="El asunto es requerido."
                    v-model="binnacleModel.subject"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-md-4 ">
                <div class="color-secondary-6 font-14">
                  Archivo:
                </div>
                <custom-file-input
                  ref="file"
                  accept=".pdf"
                  display-style="normal"
                  v-model="binnacleModel.file"
                  :on-download="() => {}"
                />
              </div>
            </div>
            <div class="mt-4 mb-3">
              <label class="form-label color-secondary-6 font-14">
                Comentario de la Bitácora:
              </label>
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <custom-text-area
                  placeholder="Escriba Comentario"
                  v-model="binnacleModel.comment"
                  :maxlength="3000"
                  :error="errors[0]"
                  custom-error-msg="El comentario es requerido."
                  :show-char-count="true"
                  :count-classes="['d-block text-right']"
                />
              </validation-provider>

              <div class="d-flex flex-row-reverse bd-highlight">
                <div>
                  <action-button
                    variant="mt-4 success px-3"
                    text="Guardar"
                    i="fas fa-save"
                    @click="saveBinnacle"
                  ></action-button>
                </div>
                <div>
                  <action-button
                    @click="onToggle"
                    variant="mt-4 outline-danger mr-3 px-3"
                    text="Cancelar"
                    type="button"
                    i="fas fa-times-circle"
                  ></action-button>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
        <div
          v-if="showAdditionalInfo || showTransferRequestInfo"
          class="px-3 py-4"
        >
          <div class="bg-white px-4 py-2 rounded">
            <custom-tab
              no-nav-style
              nav-class="mb-4 mx-0 w-100"
              :default-active-tab="activeTab"
            >
              <custom-tab-item
                title="Información Adicional"
                nav-item-class="w-50 text-center"
                nav-link-class="fs-17"
              >
                <additional-info class="px-1" :item="item" />
              </custom-tab-item>
              <custom-tab-item
                v-if="item.transfer?.id"
                title="Información de Transferencia"
                nav-item-class="w-50 text-center"
                nav-link-class="fs-17"
              >
                <transfer-request-info
                  :transfer-id="item.transfer?.id"
                  @close="onCancelAction"
                  @refresh="onCloseCallout"
                />
              </custom-tab-item>
            </custom-tab>
          </div>
        </div>
        <div v-if="showUpdateLocation" class="px-5 py-4">
          <update-location :item="item" @close="onCancelAction()" />
        </div>
        <div v-if="showLoanForm" class="px-5 py-4">
          <loan
            :item="item"
            :centers="centers"
            @close="onCancelAction()"
            @save="handlerLoanEquipment"
          />
        </div>
        <div v-if="showSeizeForm" class="px-5 py-4">
          <confiscate-equipment
            :item="item"
            @close="onCancelAction()"
            @save="handlerConfiscate"
          />
        </div>
        <div v-if="showNotifyReturn" class="px-5 py-4">
          <notify-return
            :item="item"
            @close="onCancelAction()"
            @save="handlerNotifyReturn"
          />
        </div>
        <div v-if="showLoanExtensionForm" class="px-5 py-4">
          <loan-extension
            :item="item"
            @close="onCancelAction()"
            @save="handlerNotifyExtensionReturnDate"
          />
        </div>
        <div v-if="showBinnacleHistory" class="px-5 py-4">
          <binnacle-history :history="binnacleHistory" />
        </div>
        <div v-if="showTransferCancellation" class="px-5 py-4">
          <cancel-transfer
            :item="item"
            @close="onCancelAction()"
            @refresh="onCloseCallout"
          />
        </div>
      </template>
    </custom-callout>
    <div
      v-if="isAlertvisible"
      class="alert font-weight-bold border-top-0"
      :class="[setAlertType]"
      role="alert"
    >
      <i class="fas fa-bell-exclamation mr-1"></i>
      {{ alertMessage }}
    </div>
    <div
      v-if="isCaatMissing && isCaatAlertActivated"
      class="alert alert-danger text-danger font-weight-bold border-top-0"
      role="alert"
    >
      <i class="fas fa-exclamation-circle mr-1"></i>
      El material/equipo debe tener asignado un centro para poder marcarlo
      disponible.
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import Checkbox from 'CheckBox';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import inventoryCatalogService from '@/services/api/materialsAndEquipments.api';
import IconView from 'icon-view';
import Loan from '@/views/books/inventoryCatalog/Management/components/Loan.vue';
import ConfiscateEquipment from '@/views/books/inventoryCatalog/Management/components/ConfiscateEquipment.vue';
import AdditionalInfo from './AdditionalInfo.vue';
import UpdateLocation from './UpdateLocation.vue';
import NotifyReturn from '@/views/books/inventoryCatalog/Management/components/NotifyReturn.vue';
import mixAlert from '@/mixin/alert.mixin';
import ActionButton from '@/components/common/ActionButton.vue';
import CustomFileInput from 'CustomFileInput';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import objectToFormData from 'object-to-formdata';
import moment from 'moment';
import { date } from '@/utils/filters.js';
import peiAtServiceEquipmentStatus from '@/utils/constants/inventory/peiAtServiceEquipmentStatus';
import typeFacility from '@/utils/constants/inventory/typeFacility';
import LoanExtension from '@/views/books/inventoryCatalog/Management/components/LoanExtension.vue';
import InventoryManagementDetailTabs from '@/utils/constants/inventory/InventoryManagementDetailTabs';
import CancelTransfer from './CancelTransfer.vue';
import TransferRequest from './TransferRequest.vue';
import TransferRequestInfo from './TransferRequestInfo.vue';
import { CustomTab, CustomTabItem } from 'custom-tabs';

import transferStatuses from '@/utils/constants/inventory/peiAtServiceTransferStatus';
import PROPERTIES from '@/utils/constants/inventory/bookItemProperties';

import LocationTypes from '@/utils/constants/inventory/inventoryOrderBookLocationTypes';

const TEMPLATE_TAB_INDEX = {
  ASSIGNEQUIPMENT: 1,
  TRANSFER: 2,
  EQUIPMENTINFO: 3,
  TRANSFERCANCELLATION: 4,
  TRANSFERINFO: 5,
  TRANSFERCONFIRMATION: 6,
  UPDATELOCATION: 7,
  LOANEQUIPMENT: 8,
  BINNACLE: 9,
  SEIZE: 10,
  BINNACLEHISTORY: 11,
  NOTIFYRETURN: 12,
  LOANEXTENSION: 13,
  CANCELTRANFER: 14,
};

const TAB_ITEMS = {
  INFO: 0,
  TRANSFERINFO: 1,
};

export default {
  name: 'InventoryManagementResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    Checkbox,
    AdditionalInfo,
    IconView,
    CustomTab,
    CustomTabItem,
    ActionButton,
    CustomFileInput,
    CustomInput,
    CustomTextArea,
    UpdateLocation,
    CancelTransfer,
    TransferRequest,
    TransferRequestInfo,
    NotifyReturn,
    LoanExtension,
    ConfiscateEquipment,
    Loan,
  },
  mixins: [mixAlert, alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    order: {
      type: Object,
      required: false,
      default: null,
    },
    referral: {
      type: Object,
      required: false,
      default: null,
    },
    inventoryFlow: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    fromAcquisition: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    fromMaterialEquipmentRequests: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    outOfMyInventory: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    canViewStatusSummary: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    canSeeActionFromAnotherView: {
      type: Boolean,
      default: () => false,
    },
    checkable: {
      type: Boolean,
      default: () => false,
    },
    isCaatAlertActivated: {
      type: Boolean,
      default: () => false,
    },
    editable: {
      type: Boolean,
      default: () => false,
    },
    centers: {
      type: Array,
      default: () => [],
    },
    fromResultRequestRow: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      activeTab: TAB_ITEMS.INFO,
      selectedTemplateTabIndex: null,
      accesories: [],
      unSelectedItems: [],
      isOpen: false,
      binnacleModel: {
        subject: null,
        file: null,
        comment: null,
        materialStatusId: null,
      },
      binnacleHistory: [],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    readingMedium() {
      return this.item.properties?.find(
        (x) => x.name === PROPERTIES.ReadingMedium
      );
    },
    actionItems() {
      return [
        {
          name: 'Información Adicional',
          icon: 'fas fa-info-circle text-green',
          click: async () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
            this.activeTab = TAB_ITEMS.INFO;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Ver Detalle del Material/Equipo',
          icon: 'fas fa-bars text-green',
          visible: this.canViewStatusSummary,
          click: () => {
            this.$router.push({
              name: 'InventoryBookDetails',
              params: {
                id: this.$route.params.id,
                bookId: this.item.id,
              },
            });
          },
        },
        {
          name: 'Editar Material/Equipo',
          icon: 'fas fa-edit text-green',
          visible: this.showEditAction,
          click: () => {
            this.$router.push({
              name: 'inventory-catalog-books-edit',
              params: {
                id: this.$route.params.id,
                bookId: this.item.id,
              },
            });
          },
        },
        {
          name: 'Historial de Material/Equipo',
          icon: 'fas fa-history text-green',
          visible: this.isDetailTab,
          click: () => {
            this.$router.push({
              name: 'InventoryMaterialDetails',
              params: {
                id: this.$route.params.id,
                materialId: this.item.id,
              },
              query: { tab: InventoryManagementDetailTabs.History },
            });
          },
        },
        {
          name: 'Marcar Disponible',
          icon: 'fas fa-file-check text-green',
          visible: this.canMarkAvailable,
          click: () => this.handlerMarkAvailable(),
        },
        {
          name: 'Facilitar',
          icon: 'fas fa-arrow-to-right text-green',
          visible: this.canLoan,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.LOANEQUIPMENT;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Historial de Bitácora',
          icon: 'fas fa-clock text-green',
          visible: this.canViewStatusSummary,
          click: () => {
            this.$router.push({
              name: 'InventoryBookDetails',
              params: {
                id: this.$route.params.id,
                bookId: this.item.id,
              },
              query: { tab: InventoryManagementDetailTabs.Binnacle },
            });
          },
        },
        {
          name: 'Notificar Devolución',
          icon: 'fas fa-arrow-to-left  text-green',
          visible: this.isEquipmentAssigned || this.isEquipmentLoan,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.NOTIFYRETURN;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Notificar Extensión',
          icon: 'fas fa-clock  text-green',
          visible: this.showLoanExtensionAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.LOANEXTENSION;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Inactivar',
          icon: 'fas fa-ban text-muted',
          visible: this.showInactiveAction,
          click: this.inactive,
        },
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          visible: this.showEliminateAction,
          click: this.eliminate,
        },
        {
          name: 'Asignar Solicitud',
          icon: 'fas fa-plus-circle text-green',
          visible: this.showAssignOrder,
          click: async () => await this.assignToOrder(),
        },
        {
          name: 'Desasignar',
          icon: 'fas fa-minus-circle text-green',
          visible:
            !this.outOfMyInventory &&
            Boolean(this.order?.itemId) &&
            this.isReserved,
          click: this.unassign,
        },
        {
          name: 'Solicitud de Transferencia de Material/Equipo',
          icon: 'far fa-exchange text-green',
          visible:
            this.isAvailable &&
            this.outOfMyInventory &&
            !this.order.transfer &&
            !this.order.itemId,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.TRANSFER;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Ver Solicitud de Transferencia',
          icon: 'fas fa-info-circle text-green',
          visible: this.showTransferInfoAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.TRANSFERINFO;
            this.activeTab = TAB_ITEMS.TRANSFERINFO;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Cancelar Transferencia',
          icon: 'fas fa-times-circle text-red',
          visible: this.showCancelTransferAction,
          click: () => {
            this.selectedTemplateTabIndex =
              TEMPLATE_TAB_INDEX.TRANSFERCANCELLATION;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Decomisar',
          icon: 'fas fa-ban text-danger',
          visible: this.showSeizeAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.SEIZE;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Actualizar Localidad',
          icon: 'fas fa-map-marker-alt text-green',
          visible: this.showUpdateLocationAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.UPDATELOCATION;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Bitácora',
          icon: 'fas fa-comment text-orange',
          visible: this.canViewStatusSummary,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.BINNACLE;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Historial de Custodio ',
          icon: 'fas fa-history text-success',
          visible: this.isDetailTab || this.canSeeActionFromAnotherView,
          click: () => {
            this.$router.push({
              name: 'InventoryMaterialDetails',
              params: {
                id: this.canSeeActionFromAnotherView
                  ? this.item.catalogId
                  : this.$route.params.id,
                materialId: this.item.id,
              },
              query: { tab: InventoryManagementDetailTabs.Custodian },
            });
          },
        },
      ];
    },
    showBinnacle() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.BINNACLE;
    },
    showCancelTransferForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.CANCELTRANFER;
    },
    showAdditionalInfo() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
    },
    showTransfer() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFER;
    },
    showTransferCancellation() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFERCANCELLATION
      );
    },
    showTransferConfirmation() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFERCONFIRMATION
      );
    },
    showLoanExtensionForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.LOANEXTENSION;
    },
    showEditAction() {
      return (
        this.isProcessed &&
        this.isDetailTab &&
        this.userHasPermissions('academic.inventory.editbook')
      );
    },
    showCancelTranferAction() {
      return (
        this.inventoryFlow &&
        !this.fromAcquisition &&
        !this.outOfMyInventory &&
        this.order?.equipmentId == null
      );
    },
    showTransferInfoAction() {
      return this.hasTransfer;
    },
    showUpdateLocationAction() {
      return (
        [
          peiAtServiceEquipmentStatus.Available,
          peiAtServiceEquipmentStatus.Processed,
        ].includes(this.item.statusId) &&
        this.isDetailTab &&
        this.item.locationTypeId !== LocationTypes.CSEE.id &&
        this.userHasPermissions('academic.pei.assigncentermaterial')
      );
    },
    showSeizeAction() {
      return (
        peiAtServiceEquipmentStatus.Returned == this.item.statusId &&
        this.isDetailTab &&
        this.userHasPermissions('academic.inventory.toseizebook')
      );
    },
    showLoanExtensionAction() {
      return (
        [peiAtServiceEquipmentStatus.Loan].includes(this.item.statusId) &&
        this.isDetailTab &&
        this.item.loanId
      );
    },
    showTransferRequestInfo() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFERINFO;
    },
    showUpdateLocation() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.UPDATELOCATION;
    },
    isPanelOpen() {
      return this.fromAcquisition || this.fromResultRequestRow
        ? this.isOpen
        : this.item.isOpen;
    },
    loanTitle() {
      return this.isEquipmentAssigned || this.isEquipmentLoan
        ? 'Seleccione Accesorios para Donar'
        : 'Seleccione Accesorios para el Material/Equipo';
    },
    isReserved() {
      return (
        [peiAtServiceEquipmentStatus.Reserved].includes(this.item.statusId) &&
        this.editable
      );
    },
    isEquipmentAssigned() {
      return (
        this.item.statusId === peiAtServiceEquipmentStatus.AssignedToTeacher
      );
    },
    isEquipmentLoan() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Loan;
    },
    isPendingTransfer() {
      return this.item.statusId == peiAtServiceEquipmentStatus.PendingTransfer;
    },
    showCancelTransferAction() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.PendingTransfer &&
        this.inventoryFlow &&
        this.outOfMyInventory
      );
    },
    showConfirmTransferAction() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.Reserved &&
        this.item.transfer?.statusId == transferStatuses.OnTransferRoute &&
        this.editable
      );
    },
    canMarkAvailable() {
      return [
        peiAtServiceEquipmentStatus.Processed,
        peiAtServiceEquipmentStatus.Inactive,
        peiAtServiceEquipmentStatus.Returned,
      ].includes(this.item.statusId);
    },
    showInactiveAction() {
      return (
        this.userHasPermissions(
          'academic.inventory.inactivematerialequipment'
        ) &&
        this.canViewStatusSummary &&
        [
          peiAtServiceEquipmentStatus.Available,
          peiAtServiceEquipmentStatus.Processed,
        ].includes(this.item.statusId)
      );
    },
    showEditAction() {
      return (
        this.userHasPermissions(
          'technologyassistance.inventory.editequipment'
        ) &&
        this.canViewStatusSummary &&
        this.item.statusId == peiAtServiceEquipmentStatus.Processed
      );
    },
    showEliminateAction() {
      return (
        this.userHasPermissions('academic.inventory.deletematerialequipment') &&
        this.canViewStatusSummary &&
        ![
          peiAtServiceEquipmentStatus.Assigned,
          peiAtServiceEquipmentStatus.Reserved,
          peiAtServiceEquipmentStatus.PendingTransfer,
          peiAtServiceEquipmentStatus.Loan,
        ].includes(this.item.statusId)
      );
    },
    isProcessed() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Processed;
    },
    isInactivated() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Inactive;
    },
    isReturned() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Returned;
    },
    isAvailable() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Available;
    },
    isDetailTab() {
      return this.canViewStatusSummary && !this.fromAcquisition;
    },
    showLoanForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.LOANEQUIPMENT;
    },
    isAlertvisible() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.Loan &&
        this.item.returnDate &&
        this.isEquipmentDueDate &&
        this.item.isAlertActivated
      );
    },
    setAlertType() {
      return this.missingDaysToReturnEquipment < 0
        ? 'alert-danger text-danger'
        : 'alert-warning custom-text-warning';
    },
    missingDaysToReturnEquipment() {
      if (!this.item.returnDate) return null;

      const returnEquipmentDate = moment(this.item.returnDate);
      const currentDate = moment(new Date());
      returnEquipmentDate.set({ minute: 0, hour: 0, second: 0 });
      return returnEquipmentDate.diff(currentDate, 'days');
    },
    isEquipmentDueDate() {
      if (isNaN(this.missingDaysToReturnEquipment)) return false;
      return this.missingDaysToReturnEquipment <= 4;
    },
    alertMessage() {
      const returnEquipmentDate = date(this.item.returnDate);
      return this.missingDaysToReturnEquipment < 0
        ? `Fecha de devolución de material/equipo se encuentra vencida (${returnEquipmentDate}).`
        : `Fecha de devolución de material/equipo está próxima a vencer (${returnEquipmentDate}).`;
    },
    showSeizeForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.SEIZE;
    },
    showNotifyReturn() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.NOTIFYRETURN;
    },
    showBinnacleHistory() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.BINNACLEHISTORY
      );
    },
    isCaatMissing() {
      return this.item.checked && !this.item.caatId;
    },
    isProcessed() {
      return this.item.statusId == peiAtServiceEquipmentStatus.Processed;
    },
    canLoan() {
      return (
        [
          peiAtServiceEquipmentStatus.Available,
          peiAtServiceEquipmentStatus.Assigned,
          peiAtServiceEquipmentStatus.Loan,
        ].includes(this.item.statusId) &&
        this.isDetailTab &&
        this.userHasPermissions('academic.inventory.tofacilitatebook')
      );
    },
    showAssignOrder() {
      return (
        this.fromMaterialEquipmentRequests &&
        !this.item?.orderId &&
        !this.order?.itemId &&
        !this.outOfMyInventory &&
        this.userHasPermissions(
          'academic.materialsandequipments.requests.assignorder'
        )
      );
    },
    hasTransfer() {
      return Boolean(this.item.transfer?.id);
    },
    locationTypeName() {
      const level = Object.values(LocationTypes).find(
        (level) => level.id === this.item.locationTypeId
      );
      return level ? level.name : '-';
    },
    isLocationCSEE() {
      return this.item.locationTypeId === LocationTypes.CSEE.id;
    },
    isLocationCenter() {
      return this.item.locationTypeId === LocationTypes.CENTER.id;
    },
    isLocationSchool() {
      return this.item.locationTypeId === LocationTypes.SCHOOL.id;
    },
  },
  methods: {
    async onToggle() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;

      if (this.item.isOpen) {
        this.isOpen = false;
        this.toResetBinnacleFields();
        this.$emit('close', this.item);
        return;
      }

      this.isOpen = true;
      this.$emit('open', this.item);
    },
    onCloseCallout() {
      this.$emit('close', this.item);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
      this.$emit('refresh', this.item);
    },
    async unassign() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea desasignar el Material/Equipo "${this.item.title}"?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.unassignMaterial(this.item.id);
        this.ShowToast(
          'Éxito',
          'El material/equipo ha sido desasignado exitosamente.',
          'success'
        );
        this.order.itemId = null;
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    async inactive() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el estatus del material/equipo de ${this.item.statusName} a Inactivo?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.inactiveMaterial(this.item.id);
        this.ShowToast(
          'Éxito',
          'El material/equipo ha sido inactivado exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    async eliminate() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea eliminar el material/equipo?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.eliminateMaterial(this.item.id);
        this.ShowToast(
          'Éxito',
          'El material/equipo ha sido eliminado exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    async assignToOrder() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea asignar el Material/Equipo <b>“${this.item.title}”</b> al Número de Solicitud <b>"${this.order.requestCode}"</b>?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.assignToOrder(
          this.item.id,
          this.order.id
        );
        this.ShowToast(
          'Éxito',
          'El material/equipo ha sido asignado a la solicitud.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
        throw error;
      }
    },
    async onCancelAction() {
      this.$emit('refresh');
      await this.onToggle();
    },
    async handlerMarkAvailable() {
      try {
        if (!this.item.locationTypeId) {
          this.ShowToast(
            'El Material/Equipo debe tener una localidad asignada para poder marcar disponible.'
          );
          return;
        }
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el estatus del material/equipo de ${this.item.statusName} a Disponible?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.markAvailable(this.item.id);
        this.ShowToast(
          'Éxito',
          'El material/equipo ha sido marcado como disponible exitosamente.',
          'success'
        );
        this.$emit('refresh', this.item);
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    check(item) {
      this.$emit('check', item);
    },
    async handlerLoanEquipment(model) {
      const {
        equipmentId,
        caatId,
        reasonId,
        comment,
        studentSieId,
        returnDate,
        typeFacilityId,
        phone,
        expedient,
      } = model;
      const payload = {
        equipmentId,
        caatId,
        reasonId,
        comment,
        studentSie: studentSieId,
        returnDate,
        type: typeFacilityId,
        phone,
        expedient,
      };

      try {
        await inventoryCatalogService.loan(payload);
        const loanAction =
          typeFacilityId === typeFacility.DONACION ? 'donado' : 'prestado';
        this.ShowToast(
          'Éxito',
          `El material/equipo ha sido ${loanAction} exitosamente.`,
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data.message, 'error');
      }
    },
    async saveBinnacle() {
      this.binnacleModel.materialStatusId = this.item.statusId;
      const isValid = await this.$refs.binnacleForm.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      try {
        const payload = objectToFormData(this.binnacleModel);

        await inventoryCatalogService.addBookBinnacle(this.item.id, payload);

        this.ShowToast(
          'Éxito',
          'Se ha guardado la bitácora correctamente',
          'success'
        );
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      } finally {
        this.onToggle();
      }
    },
    toResetBinnacleFields() {
      this.binnacleModel = {
        subject: null,
        file: null,
        comment: null,
        equipmentStatusId: null,
      };
    },
    async handlerConfiscate(model) {
      try {
        await inventoryCatalogService.consfiscateBook(model);
        this.ShowToast(
          'Éxito',
          'El material/equipo ha sido decomizado exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async handlerNotifyExtensionReturnDate(model) {
      try {
        await inventoryCatalogService.nofityLoanExtensionDate(model);
        this.ShowToast(
          'Éxito',
          'Se ha extendido la fecha de devolución exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async handlerNotifyReturn(model) {
      try {
        await inventoryCatalogService.notifyReturn(this.item.id, model);
        this.ShowToast(
          'Éxito',
          'Se ha notificado la devolución exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async getBinnacles() {
      const {
        data,
      } = await inventoryCatalogService.getEquipmentBinnaclesHistory(
        this.item.id
      );

      this.binnacleHistory = data.map((item) => ({
        ...item,
        statusName: item.equipmentStatusName,
      }));
    },
    async handlerNotifyExtensionReturnDate(model) {
      try {
        await inventoryCatalogService.nofityLoanExtensionDate(model);
        this.ShowToast(
          'Éxito',
          'Se ha extendido la fecha de devolución exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.gap-y-2 {
  gap: 20px 0px;
}

.bg-white {
  ::v-deep div.bg-secondary-3 {
    background-color: white !important;
  }
}

::v-deep .dot {
  padding: 18px !important;
  margin-bottom: 1px;
}

::v-deep .title-icon {
  padding-bottom: 3px;
}
.border-left-2 {
  border-left: 2px solid #dee2e6 !important;
}
.border-bottom-2 {
  border-bottom: 2px solid #dee2e6 !important;
}
.custom-text-warning {
  color: #af6708 !important;
}
.custom-tab {
  --tab-active-color: #ff7058 !important;
}
::v-deep .fs-17 {
  font-size: 17px !important;
}
</style>
